import { configureStore } from '@reduxjs/toolkit';
import { thunk } from 'redux-thunk';
import articulosSlice from './articulos/articulosSlice';
import clientesSlice from './clientes/clientesSlice';
import documentosSlice from './documentos/documentosSlice';

const store = configureStore({
    reducer:{
        articulos: articulosSlice,
        clientes: clientesSlice,
        documentos: documentosSlice
    },
    //middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(thunk),
});

export default store;